import React from 'react';
import { useLocation } from 'react-router-dom';

const TicketDetails = () => {
    const { state } = useLocation();

    if (!state) {
        return <p>Loading...</p>;
    }

    const { title, category, description, contact_number, created_at, image_url, location_link } = state;

    return (
        <div className="bg-[#1c1c24] p-8 rounded-lg shadow-md w-full max-w-4xl mx-auto">
            <h2 className="text-2xl font-bold text-white mb-4">{title}</h2>
            <p className="text-gray-400 mb-2">Category: {category}</p>
            <p className="text-gray-400 mb-2">Date: {new Date(created_at).toLocaleDateString()}</p>
            <p className="text-gray-400 mb-2">Contact Number: {contact_number || 'Not provided'}</p>
            <p className="text-white mb-4 break-all">{description}</p>

            {/* Display Image */}
            {image_url && (
                <img
                    src={image_url && image_url.startsWith('https') ? image_url : `${process.env.REACT_APP_BACKEND_URL}/uploads/${image_url}`}
                    alt="ticket"
                    className="w-full h-[300px] object-cover rounded-lg mb-4"
                />
            )}

            {/* Display Location Link as Clickable Short URL */}
            {location_link ? (
                <div className="mb-4">
                    <h3 className="text-lg font-semibold text-white mb-2">Location</h3>
                    <a
                        href={location_link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-400 underline"
                    >
                        Open Location in Google Maps
                    </a>
                </div>
            ) : (
                <p className="text-gray-400 mb-2">Location: Not provided</p>
            )}
        </div>
    );
};

export default TicketDetails;
